/**
 * Lifecycle status for a server-driven export row. `NULL` in the DB means the
 * row predates the introduction of this column (legacy forecast exports that
 * were only persisted on success); treat such rows as `COMPLETED`.
 */
export enum ExportStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
